export default function roomFileEventListener(room) {
    return store => {
        room.addEventListeners({
            room_file_init: e => {
                store.commit('file/ROOM_FILE_INIT', e.data)
            },
            room_file_add: e => {
                store.commit('file/ADD_ROOM_FILE', e.data)
            },
            room_file_delete: e => {
                store.commit('file/DELETE_ROOM_FILE', e.data)
            },
        })
    }
}